import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=e62f7b42&scoped=true"
import script from "./Rating.vue?vue&type=script&lang=ts"
export * from "./Rating.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Rating.vue?vue&type=style&index=0&id=e62f7b42&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e62f7b42",
  "107c6146"
  
)

export default component.exports